import type { WithdrawSearchRequest, WithdrawSearchResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';

export class SearchWithdrawUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(body: WithdrawSearchRequest): Promise<WithdrawSearchResponse> {
    if (!body || typeof body !== 'object') {
      throw new Error('body is required');
    }
    return this.repository.searchWithdraw(body);
  }
}


